import { render, staticRenderFns } from "./ChatDialog.vue?vue&type=template&id=5feeac2b&"
import script from "./ChatDialog.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ChatDialog.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ChatDialog.vue?vue&type=style&index=0&id=5feeac2b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports